$(function() {
  
  // based on https://observablehq.com/@gianordoli/intersection-observer-tutorial
  // use https://github.com/w3c/IntersectionObserver/tree/master/polyfill

  var callback = function (entries, observer) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        // play the individual target.timeline
        entry.target.timeline.play();
      } else {
        // could pause or reset timeline
        // for continuing or replaying animation when element is scrolled past multiple times
        //entry.target.timeline.pause(0);
      }
    });
  };

  var options = {
    threshold: 0.1, // target 'section' should be 60% visible
    rootMargin: '0px 0px -30% 0px'
  };

  var observer = new IntersectionObserver(callback, options);
  var targets = [];

//   Create animations for each element, add them to the targets array to run them when visible
//   targets.forEach(function(target) {

//     var thisBorder = $(target).find('.border');
//     var thisCircle = $(target).find('.circle');
//     var thisWrap = $(target).find('.wrap');
//     var thisYear = $(target).find('.year');

//     var action = gsap.timeline({paused:true})
//     .from(thisWrap, {autoAlpha:0, x:-100, duration:1},0)
//     .to(thisBorder, {height:'100%', duration:1, ease:'none'},0)
//     .from(thisCircle, {scale:0, transformOrigin:'center', duration:0.5}, '-=0.65')
//     .from(thisYear, {autoAlpha:0, duration:1})

//     target.timeline = action;
//   });
  
  // our story section
  if ($('#shopify-section-1489284503681').length) {
    var target = $('#shopify-section-1489284503681')[0]; // Note - base element cannot be jQuery instance
    var action = gsap.timeline({paused: true})
    .from($(target).find('.featured-link--image .image-element__wrap'), {autoAlpha: 0, y: 100, duration: 1.3}, 0);

    target.timeline = action;
    targets.push(target);
  }
  
  // two-column image with colored blocks section
  if ($('#shopify-section-1591797087464').length) {
    var target = $('#shopify-section-1591797087464')[0]; 
    var action = gsap.timeline({paused: true})
    .from($(target).find('.image-element__wrap img'), {autoAlpha: 0, y: 200, duration: 1.5}, 0)
    .from($(target).find('.colored-block-element-1'), {autoAlpha: 0, x: -400, duration: 1.5}, 0)
    .from($(target).find('.colored-block-element-2'), {autoAlpha: 0, x: 400, duration: 1.5}, 0);

    target.timeline = action;
    targets.push(target);
  }
  
  // Testimonials section
  if ($('#shopify-section-1591797648228').length) {
  	var target = $('#shopify-section-1591797648228')[0];
    $('.animated-cat-gif.original-element').clone().removeClass('hidden original-element').appendTo(target);
    $('.animated-otter-gif.original-element').clone().removeClass('hidden original-element').appendTo(target);
    
    var action = gsap.timeline({paused: true, repeat: -1})
    .set($(target).find('.animated-cat-gif'), {yPercent: 0})
    .set($(target).find('.animated-otter-gif'), {yPercent: 0})
    .fromTo($(target).find('.animated-cat-gif'), {yPercent: 0}, {yPercent: -100, duration: 2, delay: 2})
    .fromTo($(target).find('.animated-cat-gif'), {yPercent: -100}, {yPercent: 0, duration: 2, delay: 4})
    .fromTo($(target).find('.animated-otter-gif'), {yPercent: 0}, {yPercent: -90, duration: 2, delay: 2})
    .fromTo($(target).find('.animated-otter-gif'), {yPercent: -90}, {yPercent: 0, duration: 2, delay: 4});
    
    target.timeline = action;
    targets.push(target);
  }
  
  // About Dr. Sylma section
  if ($('#shopify-section-1592233716949').length) {
  	var target = $('#shopify-section-1592233716949')[0];
    $('.animated-dog-gif.original-element').clone().removeClass('hidden original-element').appendTo(target);
    
    var action = gsap.timeline({paused: true})
    .set($(target).find('.animated-dog-gif'), {yPercent: 0})
    .fromTo($(target).find('.animated-dog-gif'), {yPercent: 0}, {yPercent: -95, duration: 2, delay: 2})
    
    target.timeline = action;
    targets.push(target);
  }

  // Looping through the ELEMENTS and adding them as targets of the observer
  // https://developer.mozilla.org/en-US/docs/Web/API/NodeList#Example
  if (targets.length) {
  	Array.prototype.forEach.call(targets, (el) => {observer.observe(el);});
  }
});